import React from 'react';
import { compose } from 'ramda';
import { useSubscriptionOnSummaryUpdates, withSubscribeSummaryActions } from '../withLeaderBoardList';
import useUpdateLeaderBoards from './useUpdateLeaderBoards';

export default compose(
    withSubscribeSummaryActions,
    Wrapped => (props) => {
        useSubscriptionOnSummaryUpdates(props);
        useUpdateLeaderBoards(props);

        return <Wrapped {...props} />;
    }
);
